var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      Object.keys(_vm.selectedStudent).length > 0 &&
      _vm.roleRules.REPORTS_FLG === "Y"
        ? [
            _c("section", [
              _c(
                "div",
                { staticClass: "table-responsive" },
                [
                  _c(
                    "table-editable-list",
                    {
                      attrs: {
                        columns: _vm.columns,
                        "show-select": false,
                        "show-actions": false
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "data-row" },
                        [
                          _vm._l(_vm.files, function(year, yearIdx) {
                            return [
                              year.SCHOOL_YEAR_DESC.length > 0
                                ? _c("tr", { key: "year_" + yearIdx }, [
                                    _c("td", { attrs: { colspan: "3" } }, [
                                      _c("strong", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(year.SCHOOL_YEAR_DESC) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ])
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(year.FILES, function(letter, letterIdx) {
                                return [
                                  _c(
                                    "table-list-row",
                                    {
                                      key:
                                        "letter_" + yearIdx + "_" + letterIdx,
                                      attrs: {
                                        columns: _vm.columns,
                                        rowdata: letter,
                                        rowIndex: letterIdx,
                                        showActions: false,
                                        useAnchor: true
                                      }
                                    },
                                    [
                                      _c("template", { slot: "name" }, [
                                        _c(
                                          "a",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            attrs: {
                                              href: letter.REPORT_URL,
                                              target: "_blank",
                                              tabindex: "0",
                                              "aria-label": _vm.$t(
                                                "MAIN_CONTENT.ReportFiles.ariaNewTabMessage"
                                              )
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticStyle: { color: "#333333" },
                                              attrs: {
                                                icon: _vm.getIcon(letter)
                                              }
                                            }),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(letter.REPORT_TITLE) +
                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                            ),
                                            _c("aria-new-tab-message", {
                                              attrs: {
                                                message: _vm.$t(
                                                  "MAIN_CONTENT.Accessibility.opensInNewTab"
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                ]
                              })
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ]
        : [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.$t(
                    "MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod"
                  )
                ) +
                "\n\t"
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }